import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { updateMetaTags, injectStructuredData, generateOrganizationSchema } from '../utils/seo';

const SEOHelmet = ({ 
  title, 
  description, 
  keywords, 
  image, 
  type = 'website',
  structuredData 
}) => {
  const location = useLocation();
  const url = `https://mdsweets.shop${location.pathname}`;

  useEffect(() => {
    // Update meta tags
    updateMetaTags({
      title,
      description,
      keywords,
      image,
      url,
      type
    });

    // Inject structured data
    if (structuredData) {
      injectStructuredData(structuredData);
    } else {
      // Default to organization schema
      injectStructuredData(generateOrganizationSchema());
    }
  }, [title, description, keywords, image, url, type, structuredData]);

  return null; // This component doesn't render anything
};

export default SEOHelmet;
